module.exports = __webpack_public_path__ + "img/Logo.e68f0350.png";